import { Link } from "react-router-dom";
import { Sprout, Instagram, Mail } from "lucide-react";
import { SITE } from "../config/site";
import { NAV_LINKS } from "./Header";

export const Footer = () => (
  <footer data-testid="footer" className="bg-plum text-white mt-0">
    <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-8 rounded-full bg-lilac flex items-center justify-center">
            <Sprout className="w-4 h-4 text-white" />
          </span>
          <span className="font-serif text-2xl">{SITE.brand}</span>
        </div>
        <p className="text-white/60 text-sm leading-relaxed max-w-xs">
          Formula botanica pensata per ridurre la caduta dei tuoi capelli e riequilibrare il tuo cuoio capelluto.
        </p>
        <div className="flex gap-3 mt-6">
          <a
            data-testid="footer-instagram-link"
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-white/10 hover:bg-lilac flex items-center justify-center transition-colors"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            data-testid="footer-email-link"
            href={`mailto:${SITE.email}`}
            className="w-10 h-10 rounded-full bg-white/10 hover:bg-lilac flex items-center justify-center transition-colors"
            aria-label="Email"
          >
            <Mail className="w-4 h-4" />
          </a>
        </div>
      </div>
      <div>
        <p className="uppercase text-xs font-semibold tracking-[0.25em] text-lilac-light mb-5">Navigazione</p>
        <div className="grid grid-cols-2 gap-2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              data-testid={`footer-nav-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-white/60 hover:text-white transition-colors py-1"
            >
              {link.name}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <p className="uppercase text-xs font-semibold tracking-[0.25em] text-lilac-light mb-5">Le nostre promesse</p>
        <ul className="space-y-3 text-sm text-white/60">
          <li>Formula botanica, senza siliconi e senza parabeni</li>
          <li>Non testato su animali</li>
          <li>Prodotto artigianale</li>
          <li>Pagamenti sicuri con Stripe</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
      © {new Date().getFullYear()} {SITE.brand} · {SITE.website} · Tutti i diritti riservati
    </div>
  </footer>
);
